import AnimationFadeIn from "@components/AnimationFadeIn";
import Breadcrumb from "@components/Breadcrumb";
import HeroCst from "@components/HeroCst";
import ModalConfirmsCst from "@components/ModalConfirmsCst";
import { StatusEnum } from "@components/ModalConfirmsCst/types";
import { useFetchDataDetail } from "@hooks/useFetchDetail";
import { ArrowCircleLeft } from "@mui/icons-material";
import {
  Box,
  Container,
  Grid,
  Link,
  Typography,
  // useMediaQuery,
  useTheme,
} from "@mui/material";
import Navigation from "@pages/Contents/Corporate/CollectCampaigns/components/navigation/Navigation";
import { useCollectCampaignState } from "@pages/Contents/Corporate/CollectCampaigns/context/CollectCampaignContext";
import { ServicesURL } from "@utils/utilsApi";
import { PagesID } from "@utils/utilsConfigurations";
import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useLocation, useMatches, useParams } from "react-router-dom";
import {
  CollectCampaignDto,
  CreateTemplate,
  General,
  GroupDetailDto,
  LearningObjectProps,
  SetLos,
  UnitType,
  UserListingWebResponse,
} from "../types";
import { ColumnsType } from "src/interfaces/Common";
import { KeyedMutator } from "swr";

const EditCampaign: React.FC = () => {
  const { t } = useTranslation(["collect-campaign-page"]);
  // const { t: inputTranslations } = useTranslation(["input"]);
  const { id, idCampaign } = useParams();
  const { dispatch } = useCollectCampaignState();
  const [openToast, setOpenToast] = useState<{
    s: StatusEnum;
    message: string;
    description?: string;
  }>();
  const matches = useMatches();
  const location = useLocation();
  const { t: commonTranslations } = useTranslation(["common"]);
  const findPathIndex = matches.findIndex(
    (el) => el.pathname === location.pathname,
  );

  const {
    columns,
    dataDetail: generalData,
    isLoading: isGeneralDataLoading,
    mutate: mutateGeneralData,
  } = useFetchDataDetail(
    `${ServicesURL.getCampaign.replace(":corporateId", id ? id : "1").replace(":campaignId", idCampaign ?? "")}`,
    PagesID["corporate.collect-campaign.add"],
  ) as {
    columns: ColumnsType[];
    dataDetail: CollectCampaignDto | [];
    isLoading: boolean;
    mutate: KeyedMutator<any>;
  };
  const {
    dataDetail: loData,
    isLoading: isLoDataLoading,
    mutate: mutateLearningObjects,
  } = useFetchDataDetail(
    ServicesURL.getCampaignLearningObjects
      .replace(":corporateId", id ? id : "1")
      .replace(":campaignId", idCampaign ?? ""),
    PagesID["corporate.collect-campaign.add"],
  ) as {
    dataDetail: SetLos | [];
    isLoading: boolean;
    mutate: KeyedMutator<any>;
  };

  const {
    dataDetail: groupsData,
    isLoading: isGroupsDataLoading,
    mutate: mutateGroups,
  } = useFetchDataDetail(
    ServicesURL.findCampaignGroups
      .replace(":corporateId", id ? id : "1")
      .replace(":campaignId", idCampaign ?? ""),
    PagesID["corporate.collect-campaign.add"],
  ) as {
    dataDetail: GroupDetailDto[];
    isLoading: boolean;
    mutate: KeyedMutator<any>;
  };

  const {
    dataDetail: exclusionsData,
    isLoading: isExclusionsDataLoading,
    mutate: mutateExclusions,
  } = useFetchDataDetail(
    ServicesURL.findCampaignExclusions
      .replace(":corporateId", id ? id : "1")
      .replace(":campaignId", idCampaign ?? ""),
    PagesID["corporate.collect-campaign.add"],
  ) as {
    dataDetail?: string;
    isLoading: boolean;
    mutate: KeyedMutator<any>;
  };

  const {
    dataDetail: ownersData,
    isLoading: isOwnersDataLoading,
    mutate: mutateOwners,
  } = useFetchDataDetail(
    ServicesURL.getCampaignOwners
      .replace(":corporateId", id ? id : "1")
      .replace(":campaignId", idCampaign ?? ""),
    PagesID["corporate.collect-campaign.add"],
  ) as {
    dataDetail: UserListingWebResponse | [];
    isLoading: boolean;
    mutate: KeyedMutator<any>;
  };

  const {
    dataDetail: certificateTemplateData,
    isLoading: isCertificateTemplateDataLoading,
    mutate: mutateCertificateTemplate,
  } = useFetchDataDetail(
    ServicesURL.getCampaignCertificateTemplate
      .replace(":corporateId", id ? id : "1")
      .replace(":campaignId", idCampaign ?? ""),
    PagesID["corporate.collect-campaign.add"],
  ) as {
    dataDetail: CreateTemplate | [];
    isLoading: boolean;
    mutate: KeyedMutator<any>;
  };

  // const {
  //   dataDetail: certificateTemplateFile,
  //   isLoading: isCertificateTemplateFileLoading,
  // } = useFetchDataDetail(
  //   ServicesURL.downloadCampaignCertificateTemplate
  //     .replace(":corporateId", id ? id : "1")
  //     .replace(":campaignId", idCampaign ?? ""),
  //   PagesID["corporate.collect-campaign.add"],
  // );

  // const dispatchData = (generalData: CollectCampaignDto, loData?: CollectCampaignLoDto[], groupsData?:GroupDetailDto[], exclusionsData?: string,)

  const theme = useTheme();
  // const isLargeScreen = useMediaQuery(theme.breakpoints.down("xl"));

  const steps = [t("general"), t("owners"), t("lo"), t("users"), t("template")];

  // function handleGeneralDataChange(dataDetail: CollectCampaignDto) {
  //   if (!idCampaign && !dataDetail) return;
  //   dispatch({
  //     type: "RESET_ALL_INPUT_VALUES",
  //   });
  //   dispatch({
  //     type: "SET_GENERAL",
  //     payload: {
  //       name: dataDetail.name,
  //       end_date: dataDetail.end_date,
  //       is_learner_visible: dataDetail.is_learner_visible,
  //       start_date: dataDetail.start_date,
  //       target: dataDetail.target,
  //       unit: dataDetail.unit as UnitType
  //     }
  //   })
  // }

  // function handleGroupsDataChange(groupsData?: GroupDetailDto[], exclusionsData?: string) {
  //   if(!idCampaign) return;
  //   console.info('groups', groupsData, exclusionsData);
  //   dispatch({
  //     type: "SET_USERS",
  //     payload: {
  //       groups: groupsData?.map(({id}) => id),
  //       // exclusions: exclusionsData
  //     }
  //   })
  // }

  // function handleOwnersDataChange(ownersData?: UserListingWebResponse) {
  //   if(!idCampaign) return;
  //   console.info('owners', ownersData);
  //   dispatch({
  //     type: "SET_OWNERS",
  //     payload: ownersData?.output.map(({id_user}) => id_user)
  //   })
  // }

  // if (dataDetail && Object.keys(state).length === 0) {
  //   handleDataDetailChange(dataDetail);
  // }

  const hasResetRef = useRef(false);

  useEffect(() => {
    hasResetRef.current = false;
    if (idCampaign && !hasResetRef.current) {
      dispatch({ type: "RESET_ALL_INPUT_VALUES" });
      hasResetRef.current = true;
    }
  }, [idCampaign, dispatch]);
  useEffect(() => {
    if (!hasResetRef.current) return;
    if (!isLoDataLoading && !isGeneralDataLoading) {
      if (!idCampaign) return;
      if (!Array.isArray(generalData) && !generalData.all_learning_objects) {
        dispatch({
          type: "SET_LOS",
          payload: loData,
        });
      }
    }
  }, [loData, isLoDataLoading, isGeneralDataLoading, idCampaign, dispatch]);

  useEffect(() => {
    if (!hasResetRef.current) return;
    if (!isGeneralDataLoading) {
      if (generalData) {
        if (!idCampaign) return;
        const data = generalData as General;
        dispatch({
          type: "SET_GENERAL",
          payload: {
            name: data.name,
            end_date: data.end_date,
            is_learner_visible: data.is_learner_visible,
            start_date: data.start_date,
            target: data.target,
            unit: data.unit as UnitType,
          },
        });
      }
    }
  }, [isGeneralDataLoading, generalData, idCampaign, dispatch]);

  useEffect(() => {
    if (!hasResetRef.current) return;
    if (
      !isGroupsDataLoading &&
      !isExclusionsDataLoading &&
      !isGeneralDataLoading
    ) {
      if (!idCampaign) return;
      let exclusionFile: File | undefined = undefined;
      if (
        exclusionsData &&
        (generalData as CollectCampaignDto).has_exclusions
      ) {
        exclusionFile = new File([exclusionsData], "exclusions.csv", {
          type: "text/csv",
        });
      }
      dispatch({
        type: "SET_USERS",
        payload: {
          groups: groupsData.map(({ id }) => id),
          exclusions: exclusionFile,
        },
      });
    }
  }, [
    isGroupsDataLoading,
    isExclusionsDataLoading,
    isGeneralDataLoading,
    generalData,
    groupsData,
    exclusionsData,
    idCampaign,
    dispatch,
  ]);

  useEffect(() => {
    if (!hasResetRef.current) return;
    if (!isOwnersDataLoading) {
      if (!idCampaign) return;
      if (ownersData && !Array.isArray(ownersData)) {
        dispatch({
          type: "SET_OWNERS",
          payload: ownersData.output.map(({ id_user }) => id_user),
        });
      }
    }
  }, [isOwnersDataLoading, ownersData, idCampaign, dispatch]);

  useEffect(() => {
    if (!hasResetRef.current) return;
    if (
      !isCertificateTemplateDataLoading
      //  &&
      // !isCertificateTemplateFileLoading
    ) {
      if (!idCampaign) return;
      if (
        certificateTemplateData &&
        !Array.isArray(certificateTemplateData)
        //  &&
        // certificateTemplateFile &&
        // !Array.isArray(certificateTemplateFile)
      ) {
        dispatch({
          type: "SET_TEMPLATE",
          payload: {
            data: {
              template_filename: certificateTemplateData.template_filename,
              validity_end_date: certificateTemplateData.validity_end_date,
              validity_start_date: certificateTemplateData.validity_start_date,
            },
            // zip: certificateTemplateFile,
          },
        });
      }
    }
  }, [
    isCertificateTemplateDataLoading,
    // isCertificateTemplateFileLoading,
    certificateTemplateData,
    // certificateTemplateFile,
    dispatch,
    idCampaign,
  ]);

  const handleRedirect = () => {
    const redirectPath = matches[findPathIndex - 1]?.pathname;

    if (redirectPath) {
      window.location.assign(redirectPath);
    }
  };

  return (
    <AnimationFadeIn>
      {/* <BackgroundImageCst
        customWidth={"100%"}
        customHeight={"603px"}
        image="section-survey.jpg"
        position={"absolute"}
        fullpage={true}
      /> */}
      <Breadcrumb />
      <Container
        maxWidth={"xxl"}
        sx={{
          position: "relative",
          zIndex: 1,
        }}
      >
        <HeroCst
          title={t("edit.hero-title")}
          description={t("edit.hero-description")}
        />
        <Box
          sx={{
            mt: "25px",
          }}
        >
          <Link
            component="button"
            sx={{
              color: "white",
              display: "flex",
              alignItems: "center",
              gap: "8px",
              mb: "24px",
              "&:hover": {
                textDecoration: "underline",
              },
            }}
            onClick={handleRedirect}
          >
            <ArrowCircleLeft sx={{ fontSize: "32px" }} />
            <Typography sx={{ fontWeight: "600" }}>
              {commonTranslations("backButton")}
            </Typography>
          </Link>
          <Grid container>
            <Grid
              item
              lg={12}
              xl={12}
              sx={{
                justifyContent: "center",
              }}
            >
              <Box
                sx={{
                  // backgroundColor: theme.palette.background.paper,
                  // padding: "32px",
                  // minHeight: "495px",
                  flexDirection: "column",
                  justifyContent: "center",
                }}
              >
                <Navigation
                  steps={steps}
                  columns={columns}
                  onComplete={async () => {
                    await Promise.all([
                      mutateGeneralData(),
                      mutateGroups(),
                      mutateOwners(),
                      mutateCertificateTemplate(),
                      mutateExclusions(),
                      mutateLearningObjects(),
                    ]);
                  }}
                />
              </Box>
            </Grid>
          </Grid>
        </Box>
      </Container>
      <ModalConfirmsCst
        open={!!openToast}
        title={t("hero-title-edit")}
        description={""}
        onCallBackClosed={() => {
          setOpenToast(undefined);
        }}
        status={openToast}
      />
    </AnimationFadeIn>
  );
};
export default EditCampaign;
